module.exports = __webpack_public_path__ + "img/ae.537b07b0.svg";